import { Toaster as SonnerToaster, type ToasterProps } from 'sonner'

export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      theme="dark"
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-gray-900/95 group-[.toaster]:text-gray-100 group-[.toaster]:border-gray-700/50 group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-gray-400',
          actionButton:
            'group-[.toast]:bg-indigo-500 group-[.toast]:text-white',
          cancelButton:
            'group-[.toast]:bg-gray-700 group-[.toast]:text-gray-200',
        },
      }}
      {...props}
    />
  )
}
